import React from 'react'
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
    extraMargin: {
        marginRight: `${theme.custom.fieldWidth}px !important`,
    },
    fieldWrapper: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(3),
        // position: 'absolute',
        // bottom: 0,
        // right: 0
    },
    buttonProgress: {
        color: theme.palette.primary.main,
    },
    form: {
        height: '100%',
    },
})

const FormWrapper = props => {
    const { form: Form, classes, ...rest } = props
    return <Form formClasses={classes} {...rest} />
}

export default withStyles(styles)(FormWrapper)
